import { Device } from '../../shared';
declare const google;

export class Marker {
  public lat: number;
  public lng: number;
  public draggable: boolean;
  public device: Device;
  public label?: string;
  public iconUrl?: string;
  public animation;
  constructor(lat, lng, draggable, device) {
    this.lat = lat;
    this.lng = lng;
    this.draggable = draggable;
    this.device = device;
    this.animation = (google.maps && google.maps.Animation) ? google.maps.Animation.DROP : 2;
    this.iconUrl = 'assets/app/media/img/maps/red.png';
  }
  public setIconUrl(color) {
    if (['red', 'yellow', 'green', 'blue', 'purple'].includes(color)) {
      this.iconUrl = `assets/app/media/img/maps/${color}-dot.png`;
    }
  }
}
